import { render, staticRenderFns } from "./TasksStepCardView.vue?vue&type=template&id=2040e43b&scoped=true&"
import script from "./TasksStepCardView.vue?vue&type=script&lang=js&"
export * from "./TasksStepCardView.vue?vue&type=script&lang=js&"
import style0 from "./TasksStepCardView.vue?vue&type=style&index=0&id=2040e43b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2040e43b",
  null
  
)

export default component.exports